import { render, staticRenderFns } from "./MultiSelectBankKind.vue?vue&type=template&id=4a498a26"
import script from "./MultiSelectBankKind.vue?vue&type=script&lang=ts"
export * from "./MultiSelectBankKind.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports